module.exports = __webpack_public_path__ + "static/img/img16.c3b46ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img16.jpg
// module id = ilT7
// module chunks = 1